// Mock data for Kumaun University redesigned site

export const IMAGES = {
  nainitalLake:
    "https://images.unsplash.com/photo-1610715936287-6c2ad208cdbf?crop=entropy&cs=srgb&fm=jpg&q=85",
  nainitalLake2:
    "https://images.unsplash.com/photo-1586255028095-d93edb74e412?crop=entropy&cs=srgb&fm=jpg&q=85",
  // himalayan1: "https://images.unsplash.com/photo-1454496522488-7a8e488e8606?crop=entropy&cs=srgb&fm=jpg&q=85",
  // himalayan2: "https://images.unsplash.com/photo-1518002054494-3a6f94352e9d?crop=entropy&cs=srgb&fm=jpg&q=85",
  kumauncover1: "/images/administrative_block.jpeg",
  kumauncover2: "/images/Main_gate.png",
  students1:
    "https://images.unsplash.com/photo-1680084521738-87a53d7a50d8?crop=entropy&cs=srgb&fm=jpg&q=85",
  // students2: "https://images.pexels.com/photos/38431957/pexels-photo-38431957.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  students2: "/images/hermitage.png",
  pineForest1:
    "https://images.unsplash.com/photo-1440581572325-0bea30075d9d?crop=entropy&cs=srgb&fm=jpg&q=85",
  pineForest2:
    "https://images.unsplash.com/photo-1502252430442-aac78f397426?crop=entropy&cs=srgb&fm=jpg&q=85",
};

export const TICKER_NOTICES = [
  "Undergraduate Registration & Admission Open for Session 2026-27 — Last Date Extended to 10 July 2026",
  "Online Registration Open for BA LLB, BA LLB (Hons.) & BBA LLB Admissions 2026",
  "KUPPAT-2026 Second Merit List Published",
  "20th Convocation Ceremony Successfully Held in Nainital Campus",
  "Prof. Diwan S. Rawat's breakthrough molecule cleared Phase I clinical trials",
];

export const STATS = [
  { value: "50+", label: "Years of Educational", detail: "Experience" },
  { value: "250+", label: "Faculty Members", detail: "" },
  { value: "50 k+", label: "University Student's", detail: "Strength" },
  { value: "100 k+", label: "Glorious", detail: "Alumni" },
];

export const NAV_LINKS = [
  {
    title: "Home",
    items: [],
    url: "/",
  },

  {
    title: "About",
    items: [
       {
        label: "Vision Mission & Strategy",
        url: "/about/vision-mission-strategy",
      },
      {
        label: "University at a Glance",
        url: "/about/university-at-a-glance",
      },
       {
        label: "Affiliated Colleges List",
        url: "/about/colleges-list",
      },
      
      // {
      //   label: "Vice-Chancellor's Message",
      //   url: "/about/vice-chancellors-message",
      // },
      //  {
      //   label: "Vice-Chancellor Profile",
      //   url: "/about/vice-chancellor-profile",
      // },
      {
        label: "The Court",
        url: "/about/the-court",
      },
      {
        label: "Academic Council",
        url: "/about/academic-council",
      },
       {
        label: "Executive Council",
        url: "/about/executive-council",
      },
      {
        label: "Finance Committee",
        url: "/about/finance-committee",
      },
      
     
      {
        label: "University Administration",
        children: [
          {
            label: "Vice Chancellor",
           url: "/about/vice-chancellor-profile",
          },
          {
            label: "Registrar",
            url: "/about/university-administration/registrar",
          },
          {
            label: "Finance Controller",
            url: "/about/university-administration/finance-controller",
          },
          {
            label: "Exam Controller",
            url: "/about/university-administration/exam-controller",
          },
          {
            label: "Deputy Exam Controller",
            url: "/about/university-administration/deputy-exam-controller",
          },
          {
            label: "Other Official",
            url: "/about/university-administration/other-official",
          },
        ],
      },
      {
        label: "Campus Administration",
        children: [
          {
            label: "Directors",
            url: "/about/campus-administration/directors",
          },
          {
            label: "Deans",
            url: "/about/campus-administration/deans",
          },
          {
            label: "Heads",
            url: "/about/campus-administration/heads",
          },
        ],
      },
      {
        label: "Infrastructure & Facilities",

        children: [
          {
            label: "Hostel",
            url: "/infrastructure-facilities/hostel",
          },
          {
            label: "Medical Facilities",
            url: "/infrastructure-facilities/medical-facilities",
          },
          {
            label: "Himalayan Museum",
            url: "/infrastructure-facilities/himalayan-museum",
          },
        ],
      },
      {
        label: "Campus",
        url: "/about/campus",
      },
    ],
  },
  {
    title: "Affiliation",
    items: [
      {
        label: "Online Affiliation Portal",
        url: "https://uttarakhandaffiliation.in/login.php",
      },
      // {
      //   label: "Affiliated Colleges List",
      //   url: "affiliation/colleges-list",
      // },
    ],
  },

  

  {
    title: "Faculties",
    items: [],
  },

  {
    title: "Admission",
    items: [
      {
        label: "UG Admissions",
        url: "https://ukadmission.samarth.ac.in/",
      },
      {
        label: "PG Admissions",
        url: "https://ukpgadmission.samarth.ac.in/index.php/site/",
      },
      // {
      //   label: "Admissions Rules",
      //   url: "/admission/rules",
      // },
      // {
      //   label: "Students Intake of all Govt. Colleges",
      //   url: "/admission/students-intake",
      // },
    ],
  },

  // {
  //   title: "R & D Cell",
  //   items: [
  //     "Schedules",
  //     "Admit Cards",
  //     "Results",
  //     "Provisional Degree",
  //     "Original Degree",
  //     "RTI",
  //   ],
  // },

  // {
  //   title: "Event",
  //   items: [
  //     "DSB Campus, Nainital",
  //     "SSJ Campus, Almora",
  //     "BMS Campus, Bhimtal",
  //     "Hostels",
  //     "Library",
  //     "Sports",
  //   ],
  // },

  

  {
    title: "Examination Cell",
    url: "/examination-cell",
  },
  {
    title: "Central Library",
    // items: [],
    url: "/central-library",
  },
  
{
    title: "Research",
    items: [
        {
        label: "Research Funding Agencies",
        url: "/research-funding-agencies",
      },
      
      
    ],
  },

  {
    title: "Cell/Club",
    items: [
        {
        label: "Internal Quality Assurance Cell (IQAC)",
        url: "/cell-club/Internal-Quality-Assurance-Cell-(IQAC)",
      },
      
      
    ],
  },
  // {
  //   title: "Events",
  //   items: [
  //       {
  //       label: "Recruitments",
  //       url: "/events/recruitments",
  //     },
      
      
  //   ],
  // },
  // student corner start
 
  // student corner end

];
export const COURSES = [
  { title: "Undergraduate Programmes", desc: "BA, BSc", tag: "UG" },
  { title: "Postgraduate Programmes", desc: "MA, MSc, MCom, MBA", tag: "PG" },
  {
    title: "PG Diploma / Diploma Courses",
    desc: "PG Diploma In Journalism and Mass Communication",
    tag: "PG Diploma / Diploma Courses",
  },
  {
    title: "VOCATIONAL COURSES",
    desc: "B.VOC. IN AUTOMOBILE TECHNOLOGY",
    tag: "Voc",
  },
  { title: "Foundation Course", desc: "", tag: "FC" },
  // { title: "Foundation Courses", desc: "NEP-aligned foundation and value-addition courses for holistic learning.", tag: "VAC", count: "25+ courses" },
];

export const PRESS_RELEASES = [
  {
    title:
      "Kumaun University 20th Convocation graced by Hon'ble President Smt. Droupadi Murmu",
    date: "18 Dec 2025",
  },
  {
    title:
      "Forensic Science Dept. & Dr. Rajendra Prasad Law Institute host Moot Court on Forensic Week",
    date: "04 Dec 2025",
  },
  {
    title:
      "Cyber Hygiene seminar organised at Dr. Rajendra Prasad Law Institute, KU",
    date: "28 Nov 2025",
  },
  {
    title:
      "VC Prof. Diwan S. Rawat congratulates Harshita Sharma on Princeton National Fellowship",
    date: "14 Nov 2025",
  },
  {
    title:
      "Golden Jubilee Year — winners of KU competitions felicitated by Vice-Chancellor",
    date: "02 Nov 2025",
  },
  {
    title:
      "Research Cell hosts 'Research Excellence Awards 2024' celebrating faculty publications",
    date: "20 Oct 2025",
  },
];

export const ANNOUNCEMENTS = [
  {
    title: "B.Sc. Agriculture Fifth Merit List 2026-27 released",
    date: "05 Jul 2026",
  },
  {
    title: "Admission Notice: Third Merit List BCA First Semester 2026-27",
    date: "03 Jul 2026",
  },
  {
    title: "Academic Calendar for session 2026-27 published",
    date: "01 Jul 2026",
  },
  {
    title: "KUPPAT-2026 Second Counselling schedule announced",
    date: "28 Jun 2026",
  },
  {
    title: "B.Ed. Second Semester (Main/Back) exam form date extended",
    date: "25 Jun 2026",
  },
  {
    title: "Kumaun University Research Ordinance-2023 (Amended)",
    date: "24 Oct 2025",
  },
];

export const TENDERS = [
  {
    title:
      "Tender: Minor construction/repair works — DSB Campus Kenfield Hostel",
    date: "02 Jul 2026",
  },
  {
    title:
      "Tender: Registered contractors invited for minor works across campuses",
    date: "28 Jun 2026",
  },
  {
    title:
      "Auction notice — unusable tin & iron grille at Administrative Building",
    date: "20 Jun 2026",
  },
  {
    title: "Journalism Dept. — studio soundproofing tender cancellation",
    date: "12 Jun 2026",
  },
];

export const ADS = [
  {
    title: "Walk-in Interview — Project Assistant, Department of Chemistry",
    date: "01 Jul 2026",
  },
  {
    title:
      "Advertisement for appointment of Vice-Chancellor, Kumaun University",
    date: "22 Jun 2026",
  },
  {
    title: "Walk-in Interview — Technical Assistant, Department of Botany",
    date: "18 Jun 2026",
  },
  {
    title: "Rescheduled Walk-in Interview — ANRF & NMHS funded projects",
    date: "10 Jun 2026",
  },
];
export const AWARDS = [
  {
    date: "15 Aug 2026",
    title: "Kumaun University receives Excellence in Higher Education Award",
  },
  {
    date: "05 Jul 2026",
    title: "University recognized for outstanding academic achievements",
  },
  {
    date: "21 Jun 2026",
    title: "Kumaun University receives Certificate of Institutional Excellence",
  },
  {
    date: "10 May 2026",
    title: "Award for Excellence in Research and Innovation",
  },
];
export const EXAM_NEWS = [
  {
    date: "10 Sep 2026",
    title: "Latest examination related news and updates",
  },
  {
    date: "05 Sep 2026",
    title: "Important examination announcement for students",
  },
  {
    date: "01 Sep 2026",
    title: "University examination latest updates",
  },
  {
    date: "28 Aug 2026",
    title: "Examination Cell important information",
  },
];

export const COLLEGE_NOTICES = [
  {
    date: "09 Sep 2026",
    title: "Notice for all affiliated colleges",
  },
  {
    date: "03 Sep 2026",
    title: "Important instructions for college examination centres",
  },
  {
    date: "29 Aug 2026",
    title: "College examination related guidelines",
  },
  {
    date: "25 Aug 2026",
    title: "Submission of examination related documents",
  },
];
export const EXAM_PRESS_RELEASES = [
  {
    date: "08 Sep 2026",
    title: "University Examination Cell Press Release",
  },
  {
    date: "30 Aug 2026",
    title: "Important examination press release",
  },
  {
    date: "22 Aug 2026",
    title: "Examination related official announcement",
  },
];

export const DOWNLOADS = [
  {
    date: "07 Sep 2026",
    title: "Examination Proforma and Application Forms",
  },
  {
    date: "01 Sep 2026",
    title: "Download Examination Related Forms",
  },
  {
    date: "24 Aug 2026",
    title: "Important Examination Documents",
  },
];

export const ORDINANCE_SYLLABUS = [
  {
    date: "05 Sep 2026",
    title: "Examination Ordinance and Regulations",
  },
  {
    date: "28 Aug 2026",
    title: "Updated Examination Syllabus",
  },
  {
    date: "20 Aug 2026",
    title: "University Examination Ordinance",
  },
];

export const EVENTS = [
  {
    day: "06",
    month: "Oct",
    year: "2025",
    title: "International Conference on Geodynamic Evolution of Himalaya",
    time: "10:00 AM",
    venue: "Deptt. of Geology, Centre of Advanced Study",
  },
  {
    day: "27",
    month: "Feb",
    year: "2025",
    title: "उद्यमिता विकास कार्यक्रम (Entrepreneurship Development)",
    time: "10:00 AM",
    venue: "Dev Singh Bisht Campus, Nainital",
  },
  {
    day: "10",
    month: "Feb",
    year: "2025",
    title: "Indian Classical Music Concert Series — 4th Edition",
    time: "11:00 AM",
    venue: "DSB Campus, Nainital",
  },
  {
    day: "09",
    month: "Jan",
    year: "2025",
    title: "Workshop on Bio-Magnetic Therapy",
    time: "11:30 AM",
    venue: "Seminar Hall, Old Arts, DSB Campus",
  },
];

export const EMINENT_GUESTS = [
  {
    name: "Hon'ble Dr. APJ Abdul Kalam",
    role: "11th President of India",
    img: "/eminent-img/APJ_Abdul_kalam.webp",
  },
  {
    name: "Prof. C. N. R. Rao",
    role: "National Research Professor, Bharat Ratna",
    img: "/eminent-img/C_N_R_Rao.webp",
  },
  {
    name: "Hon'ble NSA Mr. Ajit Doval",
    role: "National Security Advisor of India",
    img: "/eminent-img/Ajit_Doval.webp",
  },
  {
    name: "Hon'ble Dr. Karan Singh",
    role: "Politician, philanthropist & poet",
    img: "/eminent-img/Karan_Singh.webp",
  },
  {
    name: "Mahadevi Verma",
    role: "Novelist, Poetess & Educationist",
   img: "/eminent-img/Mahadevi_Verma.webp",
  },
  // { name: "Padma Shree Anup Sah", role: "Environmentalist & Nature Photographer", img: "https://d3siaoml8cnbuv.cloudfront.net/uploads/guest/1716096885.webp" },
];
export const VISITING_PROFESSORS = [
  {
    img: "/visiting-professor/P_Balram.webp",
    award :"(Padma Bhushan)",
    name: "Prof. Padmanabhan Balaram",
    role: "Indian biochemist, Former Director-Indian Institute of Science (IISc), Bangalore.",
   
  },
  {
    img: "/visiting-professor/HC_Verma.webp",
    award :"(Padma Shri)",
    name: "Prof. Harish Chandra Verma",
    role: "Indian Experimental physicist, Author, Emeritus professor-Indian Institute of Technology, Kanpur.",
  },
  {
    img: "/visiting-professor/Yashodhar-mathpal.webp",
    award :"(Padma Shri)",
    name: "Dr. Yashodhar Mathpal",
    role: "Indian Archaeologist, painter, Curator,Rock Art Conservationist, Environmentalist.",
  },
  {
    img: "/visiting-professor/Anup_Sah.webp",
    award :"(Padma Shri)",
    name: "Mr. Anup Sah",
    role: "Wildlife photographer, Mountaineer, Beekeeper, A Naturalist, Mushroom expert, Heads Nainital Mountaineering Club (NTMC).",
  },
  {
    img: "/visiting-professor/Ashutosh_Sharma.webp",
    award :"(Padma Shri), (UNESCO Medal)",
    name: "Prof. Ashutosh Sharma",
    role: "Eminent Indian chemical engineer, Nano scientist, Science policy leader  President-INSA (2023-2025) Professor-Department of Chemical Engineering (IIT Kanpur)",
  },
  {
    img: "/visiting-professor/Binghe_Wang.webp",
    award :"",
    name: "Dr. Binghe Wang",
    role: "Regents Professor of Chemistry, Frank Hannah Chair in Medicinal Chemistry, Georgia Research Alliance Eminent Scholar in Drug Discovery, Editor-in-Chief of Journal of Enzyme Inhibition & Medicinal Chemistry.",
  },
];
export const HIGHLIGHTS = [
  "A+ Category awarded to Department of Forestry & Environment by ICFRE",
  "Indira Gandhi National Service Scheme Award (2012-13)",
  "8th National Award from Ministry of Chemicals & Fertilizers, Govt. of India",
  "ISO 9001-2008 certified institute for International Quality Management",
  "651-700 in QS Asia University Rankings; 81-85 in QS India",
  "62nd Rank in Pharmacy category of NIRF Ranking",
  "27th Rank in Best University Survey by India Today Group",
  "Recognised by Bar Council of India, AICTE and Pharmacy Council of India",
];

export const CULTURE_ITEMS = [
  {
    title: "कुलगीत",
    body: "जय विश्वविद्यालय कुमाऊँ\n\
      तव सुयश, जग में बढ़ाऊँ,\n\
      ज्ञान सुधा संचय हो।\n\
      तेरी जय-जय-जय हो!\n\n\
      स्थापित मध्य हिमाद्रि चरण में,\n\
      शांत शुद्ध पर्यावरण में,\n\
      कर्मनिरत वातावरण में,\n\
      प्रज्ञा ज्योतिर्मय हो।।\n\
      तेरी जय-जय-जय हो!\n\n\
      शिक्षण-शोध विभिन्न विषयगत,\n\
      केंद्र विविध परिसर विद्याधरत,\n\
      प्रतिबिंबित सतरंगी भारत,\n\
      सद्  सुंदर शिवमय हो।।"
  },
  {
    title: "Aipan — The Sacred Folk Art",
    body: "White rice-paste patterns on ochre floors, drawn by Kumaoni women on thresholds and altars. Every motif carries meaning — from the eight-petalled Ashtadal Kamal to the enveloping Saraswati Chowki.",
  },
  {
    title: "Nanda Devi — The Guardian Goddess",
    body: "The reigning deity of the Kumaon hills. Her annual jaat and mela in September light up Nainital's Mall Road with music, doli processions and centuries-old rituals.",
  },
  {
    title: "Kumaoni Holi — A Musical Ode",
    body: "Baithki, Khadi and Mahila Holi — a month-long celebration of classical ragas sung around harmoniums, tabla and hudka. Poetry, prayer and colour, in equal measure.",
  },
  {
    title: "Pahari Cuisine & Craft",
    body: "Bhatt ki Churkani, Bal Mithai, Singhori, Aloo Ke Gutke — food shaped by the hills. Ringaal bamboo weaving, copper-work of Almora and woollen shawls of the highlands.",
  },
];
